// src/components/Login.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import { useAuth } from "../context/AuthContext";
import toast from "react-hot-toast";
import {
  Mail, Lock, Eye, EyeOff, ArrowRight,
  
} from "lucide-react";
import "./auth.css";

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await login(form.email.trim(), form.password);
      toast.success("Welcome back!");
      navigate("/dashboard");
    } catch (err) {
      const msg = err?.response?.data?.message || "Invalid email or password";
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth">
      <div className="auth-bg">
        <span className="blob blob-1" />
        <span className="blob blob-2" />
        <span className="blob blob-3" />
        <span className="grid" />
        <span className="glow" />
      </div>

      <div className="auth-shell">
        {/* Left branding */}
        <div className="auth-brand">
          <div className="brand-row d-flex flex-column align-items-center justify-content-center text-center mt-3 mb-2" style={{ width: "100%" }}>
            <img
              src="/logo.png"
              alt="Platinum Auto Japan"
              className="login-logo-img mb-3"
              style={{ width: 140, height: 140, objectFit: 'contain', filter: 'drop-shadow(0 12px 30px rgba(239, 68, 68, 0.5))' }}
              onError={(e) => { e.target.onerror = null; e.target.outerHTML = '<div class="crm-logo lg" style="margin-bottom: 20px">P</div>' }}
            />
            <div>
              <div className="brand-corporate-badge">
                OFFICIAL WORKSPACE
              </div>
              <div className="brand-title">PLATINUM AUTO JAPAN</div>
              <div className="brand-sub">
                Global Japanese Automotive Export, Auction Procurement &amp; Enterprise Sales Management.
              </div>
            </div>
          </div>
        </div>

        {/* Right card */}
        <div className="auth-card">
          <div className="card-head">
            <div className="card-kicker">ENTERPRISE ACCESS</div>
            <div className="card-title">Sign In</div>
            <div className="card-muted">Enter your authorized staff credentials to continue.</div>
          </div>

          {error && <div className="auth-alert">{error}</div>}

          <Form onSubmit={handleSubmit} className="auth-form">
            <Form.Group className="mb-3">
              <Form.Label className="auth-label">Email</Form.Label>
              <div className="auth-inputwrap">
                <span className="auth-icon"><Mail size={18} /></span>
                <Form.Control
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                  placeholder="name@company.com"
                  className="auth-input"
                  autoComplete="email"
                />
              </div>
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label className="auth-label">Password</Form.Label>
              <div className="auth-inputwrap">
                <span className="auth-icon"><Lock size={18} /></span>
                <Form.Control
                  name="password"
                  type={showPass ? "text" : "password"}
                  value={form.password}
                  onChange={handleChange}
                  required
                  placeholder="Enter your password"
                  className="auth-input"
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="auth-eye"
                  onClick={() => setShowPass((v) => !v)}
                  aria-label="Toggle password visibility"
                >
                  {showPass ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </Form.Group>

            <Button type="submit" className="auth-btn" disabled={loading}>
              {loading ? (
                <span className="btn-loading">
                  <span className="spinner" /> Signing in...
                </span>
              ) : (
                <span className="btn-inline">
                  Sign in <ArrowRight size={18} />
                </span>
              )}
            </Button>

            <div className="auth-foot">
              <span className="muted">Need access?</span>{" "}
              <span className="muted">Contact Admin.</span>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Login;